import { connect } from 'react-redux'
import get from 'lodash/get';

import {
  handleChangeSavedReportsFilter as onHandleChangeSavedReportsFilter
} from '../../actions/filterSavedReportsActions'

const mapStateToProps = (state) => ({
  filterSavedReportsDataState: state.filterSavedReports.dataState,
  filterSavedReportsCount: get(state, ['filterSavedReports', 'count'], null),
  filterSavedReportsPage: get(state, ['filterSavedReports', 'page'], null)
});

const mapDispatchToProps = {
  onHandleChangeSavedReportsFilter
}

const withFilterSavedReports = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withFilterSavedReports }